import { useEffect, useRef } from "react";
import { POLLING_INTERVAL } from "../utils/constants";

export const usePolling = (callback, dependencies = [],interval = POLLING_INTERVAL)=>{
    const intervalRef = useRef();

    useEffect(()=>{
        callback();
        intervalRef.current = setInterval(callback, interval);
        return () => {
            if(intervalRef.current) clearInterval(intervalRef.current);
        };
    },dependencies);

    const stopPolling = () => {
        if(intervalRef.current){
            clearInterval(intervalRef.current);
        }
    };

    const startPolling = () => {
        stopPolling();
        intervalRef.current = setInterval(callback, interval);
    };

    return {stopPolling, startPolling};
};